<template>
  <!-- Largada do duelo.
       Cobre a **tela inteira**, e não o tabuleiro: um contador que deixa a âncora, o
       placar e o tamanho das palavras à mostra não esconde nada — dá tempo de estudar a
       chain de graça antes de o relógio ligar. O servidor só liga o cronômetro depois
       desses segundos, então o que se vê aqui é exatamente o que já se sabe. -->
  <!-- Vai para o `body`: dentro do tabuleiro, a regra de empilhamento da tela de jogo
       (`.play > *`) reescrevia o `position` e a largada virava uma faixa no topo, com a
       âncora e as palavras à mostra logo abaixo. -->
  <Teleport to="body">
    <div class="start" role="status" aria-live="assertive">
      <div class="glow" aria-hidden="true" />

      <div class="content">
        <span class="lbl brand">{{ against ? `duelo contra ${against}` : 'duelo' }}</span>

        <span :key="seconds" class="number" :class="{ go: seconds <= 0 }">
          {{ seconds > 0 ? seconds : 'JÁ!' }}
        </span>

        <p class="note">
          {{ seconds > 0
            ? 'A chain aparece quando o relógio ligar — ninguém vê antes.'
            : `${limit} segundos para a chain inteira. Errar custa 10 pontos e 10 segundos.` }}
        </p>

        <!-- O tabuleiro embaçado diz o que vem: cinco caixas, nada legível. -->
        <div class="preview" aria-hidden="true">
          <span class="lbl">a chain de agora</span>
          <div class="boxes">
            <i v-for="n in 5" :key="n" />
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'DuelCountdown',
  props: {
    seconds: { type: Number, required: true },
    /** O tempo de partida que o servidor mandou; a tela não inventa o número. */
    limit: { type: Number, default: 90 },
    /** Nome de quem está do outro lado, quando a tela sabe. */
    against: { type: String, default: '' },
  },
};
</script>

<style scoped>
.start {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: grid;
  place-items: center;
  overflow: hidden;
  /* O mesmo chão do jogo, opaco: cobrir é o trabalho dele. */
  background: var(--bg);
  animation: enter 0.22s ease-out;
}

@keyframes enter { from { opacity: 0; } to { opacity: 1; } }

/* A marca só aparece como luz — diretiva 01. */
.glow {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: var(--brand-glow);
}

.content {
  position: relative;
  display: grid;
  justify-items: center;
  gap: 14px;
  padding: 0 26px;
  text-align: center;
}

.brand { color: var(--active); }

.number {
  font: 700 108px/1 var(--f-title);
  color: var(--text);
  animation: beat 1s ease-in-out;
}

.number.go { font-size: 62px; color: var(--ok); }

/* O número cresce, mas nunca some: começar em opacidade zero deixava um vazio no
   primeiro quadro de cada segundo. */
@keyframes beat {
  0% { transform: scale(0.72); opacity: 0.8; }
  40% { transform: scale(1.06); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
}

.note { margin: 0; max-width: 30ch; color: var(--text-3); font: 600 13px/1.5 var(--f-body); }

.preview {
  width: 100%;
  max-width: 320px;
  margin-top: 18px;
  padding: 16px;
  border-radius: 18px;
  background: var(--veil-1);
  border: 1px solid var(--line);
  filter: blur(3px);
  opacity: 0.5;
}

.preview .lbl { display: block; margin-bottom: 10px; }
.boxes { display: flex; gap: 6px; justify-content: center; }

.boxes i {
  flex: 1;
  aspect-ratio: 1;
  max-height: 46px;
  border-radius: 12px;
  background: var(--veil-3);
}

@media (prefers-reduced-motion: reduce) {
  .number { animation: none; }
}
</style>
